import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function PositiveNumber(control: AbstractControl) {
  // return (formGroup: AbstractControl): ValidationErrors | null => {
    const fControlName = control?.value;
    // consi
    // Convert string dates to Date objects for comparison
    if (fControlName <= 0) {
      return { nonPositiveValidator : true };
    }
   else{
    return null;
   }

}
